// extracted by mini-css-extract-plugin
export var modelviewer = "Modelviewer-module--modelviewer--61bf5";
export var modelviewerWrapper = "Modelviewer-module--modelviewerWrapper--a9187";